import React, {Component} from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'

class ItemErrorMessage extends Component {
    render() {
        const {error, safezone_warning} = this.props

        return (
            <td className='ItemErrorMessage'>
                <LazyLoad>

                    {!!error && error}
                    {!!safezone_warning && safezone_warning}
                </LazyLoad>
            </td>
        )
    }
}

ItemErrorMessage.defaultProps = {
    error: ''
}

ItemErrorMessage.propTypes = {
    error: PropTypes.string,
    safezone_warning: PropTypes.string
}

export default ItemErrorMessage
